// Adrian Eisenmeier: language-independent facts plus one profile file per language.
module.exports = {
  slug: 'adrian-eisenmeier',
  displayName: 'Adrian Eisenmeier',
  name: 'Dipl.-Phys. Adrian Eisenmeier',
  pdf: {
    firstName: 'Adrian',
    familyName: 'Eisenmeier',
    mobile: '+49 1515 993 4879',
    email: 'adrian.eisenmeier@paioneer.eu',
    homepage: 'paioneer-labs.eu'
  },
  pages: {
    de: require('./de.cjs'),
    en: require('./en.cjs'),
    nl: require('./nl.cjs'),
    uk: require('./uk.cjs'),
    fr: require('./fr.cjs'),
    it: require('./it.cjs'),
    es: require('./es.cjs'),
    sv: require('./sv.cjs'),
    fi: require('./fi.cjs'),
    ja: require('./ja.cjs'),
    pl: require('./pl.cjs'),
    bg: require('./bg.cjs')
  }
};
